// 宮崎県イベント・祭りクイズ100問
export const quizData = [
  // 第1章: 神話と伝説 (問1-14)
  {
    id: 1,
    category: "神話と伝説",
    question: "国の重要無形民俗文化財に指定されている「高千穂の夜神楽」で、夜を徹して奉納される神楽の数は全部でいくつとされているか？",
    options: ["十二番", "二十四番", "三十三番", "四十八番"],
    correctAnswer: 2,
    explanation: "高千穂の夜神楽は、一晩かけて三十三番の神楽を奉納する伝統的な神事です。"
  },
  {
    id: 2,
    category: "神話と伝説",
    question: "高千穂の夜神楽の「三十三番」に含まれない演目はどれか？",
    options: ["手力雄の舞", "鈿女の舞", "八岐大蛇退治", "戸取の舞"],
    correctAnswer: 2,
    explanation: "八岐大蛇退治は高千穂の夜神楽の三十三番には含まれていません。天岩戸神話を中心とした神楽が演じられます。"
  },
  {
    id: 3,
    category: "神話と伝説",
    question: "高千穂神社で毎夜奉納される観光用の夜神楽を何と呼ぶか？",
    options: ["高千穂観光神楽", "高千穂の夜神楽まつり", "高千穂神社夜神楽", "神楽殿神楽"],
    correctAnswer: 0,
    explanation: "高千穂神社では、毎夜観光客向けに「高千穂観光神楽」が奉納されています。"
  },
  {
    id: 4,
    category: "神話と伝説",
    question: "椎葉村の「椎葉神楽」の特徴として正しいものはどれか？",
    options: [
      "年に一度しか奉納されない",
      "昼間のみ奉納される",
      "各集落で独自の神楽が受け継がれている",
      "演目は全部で十二番のみ"
    ],
    correctAnswer: 2,
    explanation: "椎葉村では各集落で独自の神楽が受け継がれており、それぞれの集落で異なる演目や作法があります。"
  },
  {
    id: 5,
    category: "神話と伝説",
    question: "天岩戸神社の「天岩戸夜神楽33番大公開」が行われるのはいつか？",
    options: ["毎年1月", "毎年3月", "毎年11月", "毎年12月"],
    correctAnswer: 2,
    explanation: "天岩戸神社では、毎年11月に「天岩戸夜神楽33番大公開」が行われます。"
  },
  {
    id: 6,
    category: "神話と伝説",
    question: "日向市の「美々津おきよ祭り」で再現される歴史的な出来事は何か？",
    options: [
      "神武天皇の東征出発",
      "天孫降臨",
      "天岩戸開き",
      "海幸彦山幸彦の物語"
    ],
    correctAnswer: 0,
    explanation: "美々津おきよ祭りは、神武天皇が東征に出発した際の様子を再現するお祭りです。"
  },
  {
    id: 7,
    category: "神話と伝説",
    question: "「美々津おきよ祭り」で神武天皇が出航を急いだため、住民が慌てて作ったとされる食べ物は何か？",
    options: ["おにぎり", "切干大根", "だんご汁", "さつま揚げ"],
    correctAnswer: 1,
    explanation: "美々津では、神武天皇の急な出航に慌てて切干大根を作ったという伝説が残されています。"
  },
  {
    id: 8,
    category: "神話と伝説",
    question: "宮崎神宮で行われる「神武さま」と呼ばれる祭りの正式名称は何か？",
    options: [
      "神武天皇祭",
      "神武天皇大祭",
      "御神幸祭",
      "宮崎神宮大祭"
    ],
    correctAnswer: 2,
    explanation: "宮崎神宮の「神武さま」の正式名称は「御神幸祭」です。毎年10月に開催されます。"
  },
  {
    id: 9,
    category: "神話と伝説",
    question: "青島神社で行われる「青島裸まいり」の参加者が身につけるのは何か？",
    options: ["白装束のみ", "ふんどしのみ", "はちまきのみ", "何も身につけない"],
    correctAnswer: 1,
    explanation: "青島裸まいりでは、参加者はふんどし姿で参拝します。"
  },
  {
    id: 10,
    category: "神話と伝説",
    question: "鵜戸神宮の「鵜戸神宮春祭り」で行われる特徴的な神事は何か？",
    options: [
      "船での参拝",
      "岩への餅投げ",
      "運玉投げ",
      "海への飛び込み"
    ],
    correctAnswer: 2,
    explanation: "鵜戸神宮では、運玉を亀石の窪みに投げ入れる神事が有名です。"
  },
  {
    id: 11,
    category: "神話と伝説",
    question: "西都市の「西都古墳まつり」で再現される古代の儀式は何か？",
    options: [
      "古代の結婚式",
      "古代の葬送儀礼",
      "古代の成人式",
      "古代の即位式"
    ],
    correctAnswer: 1,
    explanation: "西都古墳まつりでは、古代の葬送儀礼が再現されます。"
  },
  {
    id: 12,
    category: "神話と伝説",
    question: "延岡市の「神話高千穂夜神楽まつり」が開催される時期はいつか？",
    options: ["春", "夏", "秋", "冬"],
    correctAnswer: 3,
    explanation: "神話高千穂夜神楽まつりは、冬の時期に開催されます。"
  },
  {
    id: 13,
    category: "神話と伝説",
    question: "高千穂町の「神話の高千穂夜神楽まつり」で、複数の神楽座が一堂に会して奉納を行う会場はどこか？",
    options: [
      "高千穂神社",
      "天岩戸神社",
      "高千穂町中央公民館",
      "高千穂峡"
    ],
    correctAnswer: 2,
    explanation: "神話の高千穂夜神楽まつりでは、高千穂町中央公民館で複数の神楽座が奉納を行います。"
  },
  {
    id: 14,
    category: "神話と伝説",
    question: "日南市の「鵜戸神宮大祭」で、特に重要な神事として行われるのは何か？",
    options: [
      "御神輿の海中渡御",
      "神楽の奉納",
      "流鏑馬",
      "相撲大会"
    ],
    correctAnswer: 0,
    explanation: "鵜戸神宮大祭では、御神輿の海中渡御が特に重要な神事として行われます。"
  },

  // 第2章: 時代を巡る行列 (問15-30)
  {
    id: 15,
    category: "時代を巡る行列",
    question: "日南市の「飫肥城下まつり」で再現される歴史的な行列は何か？",
    options: [
      "参勤交代の行列",
      "武者行列",
      "大名行列",
      "泰平踊の行列"
    ],
    correctAnswer: 3,
    explanation: "飫肥城下まつりでは、「泰平踊」という伝統的な行列が再現されます。"
  },
  {
    id: 16,
    category: "時代を巡る行列",
    question: "都城市の「都城もちまつり」で行われる特徴的なイベントは何か？",
    options: [
      "餅の早食い競争",
      "餅つき大会",
      "餅投げ大会",
      "餅を使った料理コンテスト"
    ],
    correctAnswer: 2,
    explanation: "都城もちまつりでは、大規模な餅投げ大会が行われます。"
  },
  {
    id: 17,
    category: "時代を巡る行列",
    question: "延岡市の「延岡花物語」の時期に城山に何が植えられているか？",
    options: ["桜", "梅", "つつじ", "あじさい"],
    correctAnswer: 2,
    explanation: "延岡花物語の時期、城山にはつつじが植えられており、美しい景観を作り出します。"
  },
  {
    id: 18,
    category: "時代を巡る行列",
    question: "宮崎市の「宮崎神宮大祭（神武さま）」の行列に参加する人数は約何人か？",
    options: ["約500人", "約1000人", "約1500人", "約3000人"],
    correctAnswer: 3,
    explanation: "宮崎神宮大祭の行列には、約3000人が参加すると言われています。"
  },
  {
    id: 19,
    category: "時代を巡る行列",
    question: "西都市の「西都古墳まつり」で、古代装束を身にまとった行列が向かう場所はどこか？",
    options: [
      "男狭穂塚古墳",
      "女狭穂塚古墳",
      "西都原古墳群",
      "都萬神社"
    ],
    correctAnswer: 2,
    explanation: "西都古墳まつりの行列は、西都原古墳群に向かいます。"
  },
  {
    id: 20,
    category: "時代を巡る行列",
    question: "日南市の「日南海岸きんかん・マンゴーマラソン大会」の開催時期はいつか？",
    options: ["2月", "4月", "7月", "10月"],
    correctAnswer: 0,
    explanation: "日南海岸きんかん・マンゴーマラソン大会は、2月に開催されます。"
  },
  {
    id: 21,
    category: "時代を巡る行列",
    question: "小林市の「こばやし霧島連山絶景ウォーク」で楽しめる景色は何か？",
    options: [
      "海岸線",
      "霧島連山の山々",
      "川沿いの景色",
      "市街地の夜景"
    ],
    correctAnswer: 1,
    explanation: "こばやし霧島連山絶景ウォークでは、霧島連山の美しい山々の景色を楽しめます。"
  },
  {
    id: 22,
    category: "時代を巡る行列",
    question: "椎葉村の「椎葉平家まつり」で再現されるのは、誰と誰の物語か？",
    options: [
      "那須与一と平家の姫君",
      "源頼朝と平清盛",
      "那須大八郎と鶴富姫",
      "源義経と静御前"
    ],
    correctAnswer: 2,
    explanation: "椎葉平家まつりでは、那須大八郎と鶴富姫の悲恋物語が再現されます。"
  },
  {
    id: 23,
    category: "時代を巡る行列",
    question: "日向市の「日向ひょっとこ夏祭り」で参加者が被るものは何か？",
    options: [
      "鬼の面",
      "ひょっとこの面",
      "天狗の面",
      "般若の面"
    ],
    correctAnswer: 1,
    explanation: "日向ひょっとこ夏祭りでは、参加者がひょっとこの面を被って踊ります。"
  },
  {
    id: 24,
    category: "時代を巡る行列",
    question: "都城市の「都城大弓まつり」で使われる大弓の長さは約何メートルか？",
    options: ["約1メートル", "約2メートル", "約3メートル", "約4メートル"],
    correctAnswer: 1,
    explanation: "都城大弓まつりで使われる大弓の長さは、約2メートルです。"
  },
  {
    id: 25,
    category: "時代を巡る行列",
    question: "延岡市の「のべおか天下一薪能」が開催される場所はどこか？",
    options: [
      "延岡城址",
      "今山八幡宮",
      "延岡市民文化センター",
      "行縢山"
    ],
    correctAnswer: 0,
    explanation: "のべおか天下一薪能は、延岡城址で開催されます。"
  },
  {
    id: 26,
    category: "時代を巡る行列",
    question: "日南市の「飫肥城下まつり」の「泰平踊」の参加者が着用する衣装の特徴は何か？",
    options: [
      "全員が武士の装束",
      "色とりどりの華やかな衣装",
      "全員が白装束",
      "動物の皮を使った衣装"
    ],
    correctAnswer: 1,
    explanation: "泰平踊の参加者は、色とりどりの華やかな衣装を着用します。"
  },
  {
    id: 27,
    category: "時代を巡る行列",
    question: "宮崎市の「青島太平洋マラソン」の開催時期はいつか？",
    options: ["3月", "6月", "9月", "12月"],
    correctAnswer: 3,
    explanation: "青島太平洋マラソンは、毎年12月に開催されます。"
  },
  {
    id: 28,
    category: "時代を巡る行列",
    question: "西都市の「西都花まつり」で特に有名な花は何か？",
    options: ["菜の花", "ひまわり", "コスモス", "桜"],
    correctAnswer: 0,
    explanation: "西都花まつりでは、菜の花が特に有名です。"
  },
  {
    id: 29,
    category: "時代を巡る行列",
    question: "五ヶ瀬町の「五ヶ瀬の里キャンプ村まつり」の特徴的なアクティビティは何か？",
    options: [
      "スキー体験",
      "川下り",
      "ハンググライダー体験",
      "ロッククライミング"
    ],
    correctAnswer: 2,
    explanation: "五ヶ瀬の里キャンプ村まつりでは、ハンググライダー体験が特徴的なアクティビティです。"
  },
  {
    id: 30,
    category: "時代を巡る行列",
    question: "高千穂町の「高千穂神社大祭」で奉納される伝統芸能は何か？",
    options: ["神楽", "能", "狂言", "歌舞伎"],
    correctAnswer: 0,
    explanation: "高千穂神社大祭では、神楽が奉納されます。"
  },

  // 第3章: 炎の祭典 (問31-44)
  {
    id: 31,
    category: "炎の祭典",
    question: "えびの市の「京町二日市」で行われる特徴的な火祭りの名称は何か？",
    options: [
      "火の神まつり",
      "松明行列",
      "かがり火まつり",
      "京町二日市の火祭り"
    ],
    correctAnswer: 3,
    explanation: "京町二日市では、「京町二日市の火祭り」と呼ばれる伝統的な火祭りが行われます。"
  },
  {
    id: 32,
    category: "炎の祭典",
    question: "宮崎市の「生目神社春祭り」で行われる火を使った神事は何か？",
    options: [
      "火渡り",
      "御神火焚き上げ",
      "松明競走",
      "篝火奉納"
    ],
    correctAnswer: 1,
    explanation: "生目神社春祭りでは、御神火焚き上げが行われます。"
  },
  {
    id: 33,
    category: "炎の祭典",
    question: "小林市の「小林秋まつり」の夜を彩るイベントは何か？",
    options: [
      "花火大会",
      "灯籠流し",
      "キャンドルナイト",
      "レーザーショー"
    ],
    correctAnswer: 0,
    explanation: "小林秋まつりでは、夜に花火大会が行われます。"
  },
  {
    id: 34,
    category: "炎の祭典",
    question: "日向市の「お倉ヶ浜サーフィン大会」が開催される時期はいつか？",
    options: ["春", "夏", "秋", "冬"],
    correctAnswer: 1,
    explanation: "お倉ヶ浜サーフィン大会は、夏の時期に開催されます。"
  },
  {
    id: 35,
    category: "炎の祭典",
    question: "延岡市の「延岡花火大会」の特徴的な演出は何か？",
    options: [
      "水上花火",
      "音楽と連動した花火",
      "3D花火",
      "全てが正解"
    ],
    correctAnswer: 3,
    explanation: "延岡花火大会では、水上花火、音楽と連動した花火、3D花火など、様々な特徴的な演出が行われます。"
  },
  {
    id: 36,
    category: "炎の祭典",
    question: "都城市の「都城盆地まつり」で行われる夜のメインイベントは何か？",
    options: [
      "総踊り",
      "花火大会",
      "御神輿渡御",
      "伝統芸能披露"
    ],
    correctAnswer: 0,
    explanation: "都城盆地まつりでは、夜に総踊りがメインイベントとして行われます。"
  },
  {
    id: 37,
    category: "炎の祭典",
    question: "宮崎市の「宮崎港まつり」で行われる花火大会の規模はどのくらいか？",
    options: [
      "約1000発",
      "約3000発",
      "約5000発",
      "約10000発"
    ],
    correctAnswer: 3,
    explanation: "宮崎港まつりの花火大会では、約10000発の花火が打ち上げられます。"
  },
  {
    id: 38,
    category: "炎の祭典",
    question: "日南市の「油津港まつり」で行われる夜のイベントは何か？",
    options: [
      "灯籠流し",
      "花火大会",
      "キャンドルナイト",
      "提灯行列"
    ],
    correctAnswer: 1,
    explanation: "油津港まつりでは、夜に花火大会が行われます。"
  },
  {
    id: 39,
    category: "炎の祭典",
    question: "高鍋町の「高鍋城灯籠まつり」で灯される灯籠の数は約何個か？",
    options: ["約500個", "約1000個", "約3000個", "約5000個"],
    correctAnswer: 2,
    explanation: "高鍋城灯籠まつりでは、約3000個の灯籠が灯されます。"
  },
  {
    id: 40,
    category: "炎の祭典",
    question: "新富町の「新富町花火大会」の開催場所はどこか？",
    options: [
      "一ツ瀬川河川敷",
      "新田原基地",
      "富田浜",
      "新富町総合運動公園"
    ],
    correctAnswer: 0,
    explanation: "新富町花火大会は、一ツ瀬川河川敷で開催されます。"
  },
  {
    id: 41,
    category: "炎の祭典",
    question: "川南町の「川南トロントロン軽トラ市」の特徴的なイルミネーションは何か？",
    options: [
      "軽トラックを使ったイルミネーション",
      "川に浮かべるイルミネーション",
      "木々に飾るイルミネーション",
      "建物全体を使ったイルミネーション"
    ],
    correctAnswer: 0,
    explanation: "川南トロントロン軽トラ市では、軽トラックを使った独特のイルミネーションが特徴です。"
  },
  {
    id: 42,
    category: "炎の祭典",
    question: "三股町の「三股盆地まつり」の夜のステージで披露されるのは何か？",
    options: [
      "伝統芸能",
      "音楽ライブ",
      "お笑いライブ",
      "花火"
    ],
    correctAnswer: 1,
    explanation: "三股盆地まつりの夜のステージでは、音楽ライブが披露されます。"
  },
  {
    id: 43,
    category: "炎の祭典",
    question: "高原町の「高原町花火大会」の開催時期はいつか？",
    options: ["4月", "7月", "8月", "10月"],
    correctAnswer: 2,
    explanation: "高原町花火大会は、8月に開催されます。"
  },
  {
    id: 44,
    category: "炎の祭典",
    question: "国富町の「国富町夏まつり」で行われる火を使った催しは何か？",
    options: [
      "篝火奉納",
      "花火大会",
      "松明行列",
      "火の輪くぐり"
    ],
    correctAnswer: 1,
    explanation: "国富町夏まつりでは、花火大会が行われます。"
  },

  // 第4章: 四季の恵み (問45-64)
  {
    id: 45,
    category: "四季の恵み",
    question: "西都市の「西都花まつり」で特に見頃となる花の組み合わせは何か？",
    options: [
      "桜と菜の花",
      "梅とつつじ",
      "あじさいと菖蒲",
      "コスモスとひまわり"
    ],
    correctAnswer: 0,
    explanation: "西都花まつりでは、桜と菜の花の競演が特に見事です。"
  },
  {
    id: 46,
    category: "四季の恵み",
    question: "えびの市の「えびの高原つつじ祭り」の開催時期はいつか？",
    options: ["4月", "5月", "6月", "7月"],
    correctAnswer: 1,
    explanation: "えびの高原つつじ祭りは、5月に開催されます。"
  },
  {
    id: 47,
    category: "四季の恵み",
    question: "綾町の「綾競馬大会」は、どのような形式で行われるか？",
    options: [
      "通常の競馬",
      "草競馬",
      "ばんえい競馬",
      "トロッター競馬"
    ],
    correctAnswer: 1,
    explanation: "綾競馬大会は、草競馬の形式で行われます。"
  },
  {
    id: 48,
    category: "四季の恵み",
    question: "日南市の「日南寒ひまわりまつり」が開催される時期はいつか？",
    options: ["11月", "12月", "1月", "2月"],
    correctAnswer: 2,
    explanation: "日南寒ひまわりまつりは、1月に開催されます。冬に咲くひまわりが見られます。"
  },
  {
    id: 49,
    category: "四季の恵み",
    question: "串間市の「くしま産業まつり」で特に推されている特産品は何か？",
    options: [
      "マンゴー",
      "完熟きんかん",
      "ダイヤモンドポーク",
      "伊勢海老"
    ],
    correctAnswer: 1,
    explanation: "くしま産業まつりでは、完熟きんかんが特産品として特に推されています。"
  },
  {
    id: 50,
    category: "四季の恵み",
    question: "都農町の「都農ワインまつり」で試飲できるワインの原料となるブドウは、主に町内のどこで栽培されているか？",
    options: [
      "山間部の段々畑",
      "海岸沿いの平地",
      "尾鈴山麓",
      "町の中心部"
    ],
    correctAnswer: 2,
    explanation: "都農ワインの原料となるブドウは、主に尾鈴山麓で栽培されています。"
  },
  {
    id: 51,
    category: "四季の恵み",
    question: "門川町の「かどがわ温泉祭り」で振る舞われる特産品は何か？",
    options: [
      "はまぐり",
      "伊勢海老",
      "アジ",
      "マグロ"
    ],
    correctAnswer: 0,
    explanation: "かどがわ温泉祭りでは、特産品のはまぐりが振る舞われます。"
  },
  {
    id: 52,
    category: "四季の恵み",
    question: "諸塚村の「諸塚でんき祭り」の「でんき」とは何を指すか？",
    options: [
      "電気",
      "椎茸",
      "雷",
      "伝統"
    ],
    correctAnswer: 1,
    explanation: "諸塚村の方言で「でんき」は椎茸を意味します。椎茸の産地として有名な村です。"
  },
  {
    id: 53,
    category: "四季の恵み",
    question: "美郷町の「美郷北郷区ほたるまつり」で見られるホタルの種類は主に何か？",
    options: [
      "ゲンジボタル",
      "ヘイケボタル",
      "ヒメボタル",
      "全ての種類"
    ],
    correctAnswer: 0,
    explanation: "美郷北郷区ほたるまつりでは、主にゲンジボタルが見られます。"
  },
  {
    id: 54,
    category: "四季の恵み",
    question: "高千穂町の「高千穂峡淡水魚まつり」で放流される魚は何か？",
    options: [
      "ヤマメ",
      "アユ",
      "イワナ",
      "ニジマス"
    ],
    correctAnswer: 1,
    explanation: "高千穂峡淡水魚まつりでは、アユが放流されます。"
  },
  {
    id: 55,
    category: "四季の恵み",
    question: "日之影町の「日之影町鮎まつり」の開催時期はいつか？",
    options: ["5月", "6月", "7月", "8月"],
    correctAnswer: 2,
    explanation: "日之影町鮎まつりは、7月に開催されます。"
  },
  {
    id: 56,
    category: "四季の恵み",
    question: "五ヶ瀬町の「五ヶ瀬自然塾」で体験できる農業体験の内容は何か？",
    options: [
      "稲作体験",
      "茶摘み体験",
      "そば打ち体験",
      "全てが可能"
    ],
    correctAnswer: 3,
    explanation: "五ヶ瀬自然塾では、稲作、茶摘み、そば打ちなど、様々な農業体験が可能です。"
  },
  {
    id: 57,
    category: "四季の恵み",
    question: "小林市の「小林市えびの高原の夏祭り」で行われる体験イベントは何か？",
    options: [
      "星空観察",
      "登山",
      "キャンプファイヤー",
      "全てが可能"
    ],
    correctAnswer: 3,
    explanation: "小林市えびの高原の夏祭りでは、星空観察、登山、キャンプファイヤーなど、様々な体験イベントが可能です。"
  },
  {
    id: 58,
    category: "四季の恵み",
    question: "高鍋町の「高鍋町キャベツまつり」で提供されるキャベツ料理で有名なものは何か？",
    options: [
      "キャベツ焼き",
      "キャベツ鍋",
      "キャベツ巻き",
      "全て提供される"
    ],
    correctAnswer: 3,
    explanation: "高鍋町キャベツまつりでは、キャベツ焼き、キャベツ鍋、キャベツ巻きなど、様々なキャベツ料理が提供されます。"
  },
  {
    id: 59,
    category: "四季の恵み",
    question: "新富町の「新富町ライチまつり」が開催される時期はいつか？",
    options: ["4月", "6月", "8月", "10月"],
    correctAnswer: 1,
    explanation: "新富町ライチまつりは、6月に開催されます。"
  },
  {
    id: 60,
    category: "四季の恵み",
    question: "木城町の「木城町新茶まつり」で提供される新茶の品種は何か？",
    options: [
      "やぶきた",
      "さえみどり",
      "ゆたかみどり",
      "全ての品種"
    ],
    correctAnswer: 3,
    explanation: "木城町新茶まつりでは、やぶきた、さえみどり、ゆたかみどりなど、様々な品種の新茶が提供されます。"
  },
  {
    id: 61,
    category: "四季の恵み",
    question: "川南町の「川南トマトまつり」で販売されるトマト製品で人気があるのは何か？",
    options: [
      "トマトジュース",
      "トマトケチャップ",
      "トマトジャム",
      "全て人気"
    ],
    correctAnswer: 3,
    explanation: "川南トマトまつりでは、トマトジュース、トマトケチャップ、トマトジャムなど、様々なトマト製品が人気です。"
  },
  {
    id: 62,
    category: "四季の恵み",
    question: "都城市の「都城肉まつり」で提供される肉の種類は何か？",
    options: [
      "宮崎牛のみ",
      "宮崎牛と豚肉",
      "宮崎牛と鶏肉",
      "宮崎牛、豚肉、鶏肉全て"
    ],
    correctAnswer: 3,
    explanation: "都城肉まつりでは、宮崎牛、豚肉、鶏肉など、様々な肉が提供されます。"
  },
  {
    id: 63,
    category: "四季の恵み",
    question: "三股町の「三股町お茶まつり」で体験できることは何か？",
    options: [
      "茶摘み体験",
      "茶道体験",
      "お茶の淹れ方教室",
      "全て体験可能"
    ],
    correctAnswer: 3,
    explanation: "三股町お茶まつりでは、茶摘み体験、茶道体験、お茶の淹れ方教室など、様々な体験が可能です。"
  },
  {
    id: 64,
    category: "四季の恵み",
    question: "国富町の「国富町新茶まつり」で提供される新茶の特徴は何か？",
    options: [
      "香りが強い",
      "甘みが強い",
      "渋みが少ない",
      "全ての特徴を持つ"
    ],
    correctAnswer: 3,
    explanation: "国富町新茶まつりで提供される新茶は、香りが強く、甘みがあり、渋みが少ないという特徴を持っています。"
  },

  // 第5章: 現代の賑わい (問65-80)
  {
    id: 65,
    category: "現代の賑わい",
    question: "宮崎市で開催される「みやざきグルメとランタンナイト」の特徴的な演出は何か？",
    options: [
      "巨大な花火",
      "ランタンを空に放つ",
      "プロジェクションマッピング",
      "全てが行われる"
    ],
    correctAnswer: 1,
    explanation: "みやざきグルメとランタンナイトでは、ランタンを空に放つ演出が特徴的です。"
  },
  {
    id: 66,
    category: "現代の賑わい",
    question: "宮崎市の「宮崎シーガイアトライアスロン大会」のコースに含まれていないものは何か？",
    options: [
      "スイム（水泳）",
      "バイク（自転車）",
      "ラン（ランニング）",
      "全て含まれる"
    ],
    correctAnswer: 3,
    explanation: "宮崎シーガイアトライアスロン大会には、スイム、バイク、ランの全てが含まれます。"
  },
  {
    id: 67,
    category: "現代の賑わい",
    question: "日向市の「日向ひまわりまつり」で栽培されているひまわりの本数は約何本か？",
    options: [
      "約10万本",
      "約50万本",
      "約100万本",
      "約200万本"
    ],
    correctAnswer: 2,
    explanation: "日向ひまわりまつりでは、約100万本のひまわりが栽培されています。"
  },
  {
    id: 68,
    category: "現代の賑わい",
    question: "延岡市の「延岡アスリートタウン」で開催されるスポーツイベントは何か？",
    options: [
      "マラソン大会",
      "トライアスロン大会",
      "駅伝大会",
      "全て開催される"
    ],
    correctAnswer: 3,
    explanation: "延岡アスリートタウンでは、マラソン、トライアスロン、駅伝など、様々なスポーツイベントが開催されます。"
  },
  {
    id: 69,
    category: "現代の賑わい",
    question: "小林市の「小林市国際ノルディックウォーキング大会」の開催時期はいつか？",
    options: ["春", "夏", "秋", "冬"],
    correctAnswer: 2,
    explanation: "小林市国際ノルディックウォーキング大会は、秋に開催されます。"
  },
  {
    id: 70,
    category: "現代の賑わい",
    question: "日南市の「日南海岸伊勢エビまつり」で提供される伊勢エビ料理の種類は何種類くらいか？",
    options: [
      "約5種類",
      "約10種類",
      "約20種類",
      "約50種類"
    ],
    correctAnswer: 2,
    explanation: "日南海岸伊勢エビまつりでは、約20種類の伊勢エビ料理が提供されます。"
  },
  {
    id: 71,
    category: "現代の賑わい",
    question: "串間市の「くしまアクアスロン大会」のコースに含まれるものは何か？",
    options: [
      "スイムとラン",
      "スイムとバイク",
      "バイクとラン",
      "スイム、バイク、ラン全て"
    ],
    correctAnswer: 0,
    explanation: "くしまアクアスロン大会には、スイムとランが含まれます。"
  },
  {
    id: 72,
    category: "現代の賑わい",
    question: "都城市の「都城盆地まつり」で披露される現代的なパフォーマンスは何か？",
    options: [
      "ヒップホップダンス",
      "ブレイクダンス",
      "ストリートダンス",
      "全て披露される"
    ],
    correctAnswer: 3,
    explanation: "都城盆地まつりでは、ヒップホップ、ブレイクダンス、ストリートダンスなど、様々な現代的なパフォーマンスが披露されます。"
  },
  {
    id: 73,
    category: "現代の賑わい",
    question: "えびの市の「えびの飯野植木まつり」で販売される植木の種類は何種類くらいか？",
    options: [
      "約50種類",
      "約100種類",
      "約300種類",
      "約500種類"
    ],
    correctAnswer: 2,
    explanation: "えびの飯野植木まつりでは、約300種類の植木が販売されます。"
  },
  {
    id: 74,
    category: "現代の賑わい",
    question: "綾町の「綾ユネスコエコパークまつり」で紹介される自然保護活動の内容は何か？",
    options: [
      "森林保護",
      "川の保全",
      "野生動物の保護",
      "全てが含まれる"
    ],
    correctAnswer: 3,
    explanation: "綾ユネスコエコパークまつりでは、森林保護、川の保全、野生動物の保護など、様々な自然保護活動が紹介されます。"
  },
  {
    id: 75,
    category: "現代の賑わい",
    question: "高鍋町の「高鍋町文化まつり」で展示される芸術作品の種類は何か？",
    options: [
      "絵画のみ",
      "彫刻のみ",
      "陶芸のみ",
      "様々な芸術作品"
    ],
    correctAnswer: 3,
    explanation: "高鍋町文化まつりでは、絵画、彫刻、陶芸など、様々な芸術作品が展示されます。"
  },
  {
    id: 76,
    category: "現代の賑わい",
    question: "新富町の「新富町産業まつり」で販売される農産物の種類は何種類くらいか？",
    options: [
      "約20種類",
      "約50種類",
      "約100種類",
      "約200種類"
    ],
    correctAnswer: 2,
    explanation: "新富町産業まつりでは、約100種類の農産物が販売されます。"
  },
  {
    id: 77,
    category: "現代の賑わい",
    question: "木城町の「木城町文化まつり」で披露される伝統芸能と現代芸術のコラボレーションは何か？",
    options: [
      "神楽とジャズ",
      "民謡とロック",
      "太鼓とヒップホップ",
      "全てが行われる"
    ],
    correctAnswer: 3,
    explanation: "木城町文化まつりでは、神楽とジャズ、民謡とロック、太鼓とヒップホップなど、様々なコラボレーションが行われます。"
  },
  {
    id: 78,
    category: "現代の賑わい",
    question: "川南町の「川南町産業まつり」で体験できる工業製品の製造体験は何か？",
    options: [
      "自動車部品の組み立て",
      "電子機器の組み立て",
      "食品加工",
      "全てが体験可能"
    ],
    correctAnswer: 3,
    explanation: "川南町産業まつりでは、自動車部品、電子機器、食品加工など、様々な工業製品の製造体験が可能です。"
  },
  {
    id: 79,
    category: "現代の賑わい",
    question: "都農町の「都農町産業文化まつり」で展示される伝統工芸品は何か？",
    options: [
      "陶器",
      "織物",
      "木工品",
      "全てが展示される"
    ],
    correctAnswer: 3,
    explanation: "都農町産業文化まつりでは、陶器、織物、木工品など、様々な伝統工芸品が展示されます。"
  },
  {
    id: 80,
    category: "現代の賑わい",
    question: "門川町の「門川町文化祭」で開催される音楽イベントのジャンルは何か？",
    options: [
      "クラシック",
      "ポップス",
      "ジャズ",
      "全てのジャンル"
    ],
    correctAnswer: 3,
    explanation: "門川町文化祭では、クラシック、ポップス、ジャズなど、様々なジャンルの音楽イベントが開催されます。"
  },

  // 第6章: 固有の伝統 (問81-90)
  {
    id: 81,
    category: "固有の伝統",
    question: "椎葉村の「椎葉平家まつり」で再現される「椎葉厳代神楽」の特徴は何か？",
    options: [
      "仮面を使わない",
      "女性のみが舞う",
      "独特の囃子言葉",
      "全てが特徴"
    ],
    correctAnswer: 2,
    explanation: "椎葉厳代神楽は、独特の囃子言葉を持つことが特徴です。"
  },
  {
    id: 82,
    category: "固有の伝統",
    question: "諸塚村の「諸塚神楽」で奉納される神楽の演目数は何番か？",
    options: ["十二番", "二十番", "三十番", "四十番"],
    correctAnswer: 2,
    explanation: "諸塚神楽では、三十番の神楽が奉納されます。"
  },
  {
    id: 83,
    category: "固有の伝統",
    question: "美郷町の「美郷町師走まつり」で行われる伝統的な行事は何か？",
    options: [
      "注連縄作り",
      "門松作り",
      "餅つき",
      "全てが行われる"
    ],
    correctAnswer: 3,
    explanation: "美郷町師走まつりでは、注連縄作り、門松作り、餅つきなど、様々な伝統的な行事が行われます。"
  },
  {
    id: 84,
    category: "固有の伝統",
    question: "高千穂町の「高千穂神社の神楽」で使用される楽器は何か？",
    options: [
      "太鼓と笛",
      "太鼓と鐘",
      "笛と鉦",
      "太鼓、笛、鉦全て"
    ],
    correctAnswer: 3,
    explanation: "高千穂神社の神楽では、太鼓、笛、鉦など、様々な楽器が使用されます。"
  },
  {
    id: 85,
    category: "固有の伝統",
    question: "日之影町の「日之影町神楽大会」で競われるのは何か？",
    options: [
      "演技の巧みさ",
      "衣装の美しさ",
      "音楽の調和",
      "全てが競われる"
    ],
    correctAnswer: 3,
    explanation: "日之影町神楽大会では、演技の巧みさ、衣装の美しさ、音楽の調和など、様々な要素が競われます。"
  },
  {
    id: 86,
    category: "固有の伝統",
    question: "五ヶ瀬町の「五ヶ瀬の荒踊」の特徴は何か？",
    options: [
      "激しい動き",
      "独特の掛け声",
      "勇壮な太鼓",
      "全てが特徴"
    ],
    correctAnswer: 3,
    explanation: "五ヶ瀬の荒踊は、激しい動き、独特の掛け声、勇壮な太鼓など、全てが特徴です。"
  },
  {
    id: 87,
    category: "固有の伝統",
    question: "日向市の「細島みなと祭り」で行われる伝統的な船神事は何か？",
    options: [
      "船の進水式",
      "船の清め",
      "豊漁祈願",
      "全てが行われる"
    ],
    correctAnswer: 3,
    explanation: "細島みなと祭りでは、船の進水式、船の清め、豊漁祈願など、様々な伝統的な船神事が行われます。"
  },
  {
    id: 88,
    category: "固有の伝統",
    question: "串間市の「串間市本城のひな祭り」で展示される雛人形の種類は何か？",
    options: [
      "江戸時代の雛人形",
      "明治時代の雛人形",
      "昭和初期の雛人形",
      "全ての時代の雛人形"
    ],
    correctAnswer: 3,
    explanation: "串間市本城のひな祭りでは、江戸時代から現代まで、様々な時代の雛人形が展示されます。"
  },
  {
    id: 89,
    category: "固有の伝統",
    question: "日南市の「飫肥城下町の武家屋敷群」で体験できる伝統文化は何か？",
    options: [
      "武道体験",
      "茶道体験",
      "着物体験",
      "全てが体験可能"
    ],
    correctAnswer: 3,
    explanation: "飫肥城下町の武家屋敷群では、武道体験、茶道体験、着物体験など、様々な伝統文化が体験可能です。"
  },
  {
    id: 90,
    category: "固有の伝統",
    question: "西都市の「西都原古墳群」で行われる古代体験イベントの内容は何か？",
    options: [
      "古代衣装の試着",
      "古代火起こし体験",
      "古代食の試食",
      "全てが体験可能"
    ],
    correctAnswer: 3,
    explanation: "西都原古墳群では、古代衣装の試着、古代火起こし体験、古代食の試食など、様々な古代体験イベントが可能です。"
  },

  // 第7章: 総合問題 (問91-100)
  {
    id: 91,
    category: "総合問題",
    question: "宮崎県内で最も多くの夜神楽が奉納される地域はどこか？",
    options: [
      "高千穂町",
      "椎葉村",
      "五ヶ瀬町",
      "宮崎県北西部地域全体"
    ],
    correctAnswer: 3,
    explanation: "宮崎県北西部地域全体で、多くの夜神楽が奉納されています。"
  },
  {
    id: 92,
    category: "総合問題",
    question: "宮崎県で開催される花火大会の中で、最も規模が大きいとされるのはどこか？",
    options: [
      "宮崎港まつり花火大会",
      "延岡花火大会",
      "日南海岸花火大会",
      "都城盆地まつり花火大会"
    ],
    correctAnswer: 0,
    explanation: "宮崎港まつり花火大会は、約10000発の花火が打ち上げられ、県内最大規模です。"
  },
  {
    id: 93,
    category: "総合問題",
    question: "宮崎県の特産品を使った祭りで、正しい組み合わせはどれか？",
    options: [
      "高鍋町 - キャベツまつり",
      "新富町 - ライチまつり",
      "都農町 - ワインまつり",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "高鍋町のキャベツまつり、新富町のライチまつり、都農町のワインまつりは、全て正しい組み合わせです。"
  },
  {
    id: 94,
    category: "総合問題",
    question: "宮崎県内で開催されるマラソン大会の中で、冬に開催されるのはどれか？",
    options: [
      "青島太平洋マラソン",
      "日南海岸きんかん・マンゴーマラソン",
      "延岡西日本マラソン",
      "全て冬に開催"
    ],
    correctAnswer: 3,
    explanation: "これらのマラソン大会は、全て冬の時期に開催されます。"
  },
  {
    id: 95,
    category: "総合問題",
    question: "宮崎県の神話や伝説に関連する祭りで、正しい組み合わせはどれか？",
    options: [
      "美々津 - 神武天皇東征",
      "高千穂 - 天岩戸神話",
      "西都 - 古墳時代の歴史",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "美々津の神武天皇東征、高千穂の天岩戸神話、西都の古墳時代の歴史は、全て正しい組み合わせです。"
  },
  {
    id: 96,
    category: "総合問題",
    question: "宮崎県内で開催される農産物や海産物の祭りで、正しい組み合わせはどれか？",
    options: [
      "日南市 - 伊勢エビまつり",
      "串間市 - 完熟きんかんまつり",
      "門川町 - はまぐり祭り",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "日南市の伊勢エビまつり、串間市の完熟きんかんまつり、門川町のはまぐり祭りは、全て正しい組み合わせです。"
  },
  {
    id: 97,
    category: "総合問題",
    question: "宮崎県の伝統工芸品を紹介する祭りで、正しい組み合わせはどれか？",
    options: [
      "都農町 - 陶器、織物、木工品",
      "木城町 - 伝統芸能と現代芸術のコラボ",
      "高鍋町 - 文化まつりでの芸術作品展示",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "これらの祭りは、全て宮崎県の伝統工芸品や文化を紹介する正しい組み合わせです。"
  },
  {
    id: 98,
    category: "総合問題",
    question: "宮崎県内で開催されるスポーツイベントで、正しい組み合わせはどれか？",
    options: [
      "宮崎市 - シーガイアトライアスロン",
      "延岡市 - アスリートタウンの各種大会",
      "串間市 - アクアスロン大会",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "これらのスポーツイベントは、全て正しい組み合わせです。"
  },
  {
    id: 99,
    category: "総合問題",
    question: "宮崎県の自然を活かした祭りで、正しい組み合わせはどれか？",
    options: [
      "えびの市 - えびの高原つつじ祭り",
      "西都市 - 西都花まつり（桜と菜の花）",
      "日向市 - 日向ひまわりまつり",
      "全て正しい"
    ],
    correctAnswer: 3,
    explanation: "これらの祭りは、全て宮崎県の自然を活かした正しい組み合わせです。"
  },
  {
    id: 100,
    category: "総合問題",
    question: "宮崎県の祭りやイベントの特徴として、最も適切な説明はどれか？",
    options: [
      "神話や伝説に基づく歴史的な祭りが多い",
      "豊かな自然と農産物・海産物を活かした祭りが多い",
      "伝統文化と現代文化が融合した祭りが多い",
      "全てが宮崎県の祭りの特徴"
    ],
    correctAnswer: 3,
    explanation: "宮崎県の祭りやイベントは、神話や伝説、豊かな自然、伝統文化と現代文化の融合など、全てが特徴です。"
  }
];
